import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { getChildResults } from "../../api/parentDashboardApi";

const ChildResultsTab = ({ child }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!child?.id) return;
    const load = async () => {
      try {
        setLoading(true);
        const data = await getChildResults(child.id);
        if (data?.success) setItems(data.items || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [child?.id]);

  return (
    <DataTable value={items} loading={loading} paginator rows={10} stripedRows emptyMessage="No published results.">
      <Column field="exam.name" header="Exam" sortable />
      <Column field="exam.exam_type" header="Type" />
      <Column field="exam.subject.name" header="Subject" />
      <Column
        field="exam.exam_date"
        header="Date"
        body={(row) => (row.exam?.exam_date ? new Date(row.exam.exam_date).toLocaleDateString() : "—")}
      />
      <Column
        header="Score"
        body={(row) =>
          row.is_absent ? (
            <Tag value="Absent" severity="danger" />
          ) : (
            `${row.marks_obtained ?? 0} / ${row.exam?.total_marks ?? "?"}`
          )
        }
      />
      <Column
        field="grade_letter"
        header="Grade"
        body={(row) => row.grade_letter && <Tag value={row.grade_letter} severity="success" />}
      />
    </DataTable>
  );
};

export default ChildResultsTab;
